'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  font-size: 16px;\n  font-weight: 300;\n  line-height: 19px;\n  margin-bottom: ', ';\n\n  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n    width: 100%;\n  }\n'], ['\n  font-size: 16px;\n  font-weight: 300;\n  line-height: 19px;\n  margin-bottom: ', ';\n\n  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n    width: 100%;\n  }\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Subtitle = _styledComponents2.default.h4(_templateObject, function (props) {
  return props.$alertShowing ? '0px' : '15px';
});

Subtitle.displayName = 'Subtitle';

exports.default = Subtitle;